import { registerComponent } from '@gig/magic-common';
import VerificationUploadFormComponent from './verification-upload-form.vue.js';
import VerificationUploadScanFormComponent from './verification-upload-scan-form.vue.js';

var VerificationUploadForm = registerComponent(VerificationUploadFormComponent);
var VerificationUploadScanForm = registerComponent(VerificationUploadScanFormComponent);

export { VerificationUploadForm, VerificationUploadScanForm };
